import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2, SimpleChanges } from '@angular/core';
import { UserService } from '../../../../services/Users/manage-user/user.service';
import { NotificationService } from '../../../../notification.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { UserlistComponent } from '../../reusablepages/user/userlist/userlist.component'
import { DatatransferService } from 'src/app/services/DataTransfer/datatransfer.service';
import { TeamService } from 'src/app/services/Teams/team.service';
import * as commonConstant from '../../../../../../src/app/services/common.constant';
import { ClientService } from 'src/app/services/Client/client.service';
import { Guid } from 'typescript-guid'
import { ModulesService, userRoleInfo } from 'src/app/services/Authetication/menu-permission/modules.service';
import { faClipboard, faRefresh } from '@fortawesome/free-solid-svg-icons';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-adduser',
  templateUrl: './adduser.component.html',
  styleUrls: ['./adduser.component.css']
})
export class AdduserComponent implements OnInit {
  @Input() userId: string | undefined | null;
  @Input() roles!:any[];
  @Input() getUserRole: any;
  @Input() teams: any;
  isInputFocused: boolean = false;
  @Output() refreshUserList = new EventEmitter();
  @Output() webPageToggle = new EventEmitter<boolean>();
  @ViewChild('apiAccessToken') el !: ElementRef;
  @ViewChild('teamSelect') teamSelect!: MatSelect;
  @ViewChild("checkAllSelectOptions", { read: ElementRef }) checkAllSelectOptions!: ElementRef;
  isSelectedAll:boolean = false;
  showInvalid = false;
   userFormData:any;
   teamsData: any;
  teamResponse: any = [];
  faClipboard = faClipboard;
  faRefresh = faRefresh;


  userForm = new FormGroup({
    firstName: new FormControl(),
    lastName: new FormControl(),
    email: new FormControl(),
    contactNo: new FormControl(),
    role: new FormControl(),
    team: new FormControl(),
    colorCode: new FormControl(),
    isActive: new FormControl(),
    isVisibleWebPage: new FormControl(),
    isPreview: new FormControl()
  });

  userFormdata:any;
  submitted = false;

  color: string | undefined | null;
  selectedColorCode: string | undefined | null;
  userDataById: any;
  isReadonly: boolean = false;
  loCurrentUserData: any;
  ViewclientId: any;
  ViewClienName: string | undefined | null;
  action: string | undefined | null;
  isClientAdmin = false;
  userFullName: any;
  Randomcolor = '#FF0000';
  iscolorvisible = 0;
  buttoncaption: any;
  public AccessToken: any;
  currentUserRole: any;
  filterTeam: any = [];
  selectedTeams: string[] = [];
  // for team listing
  listingBodyParameterTeamListing: any
  @Input() isWebPageToggleEnabled: boolean = false;

  constructor(private _userService: UserService,
    private renderer: Renderer2,
    private _notificationService: NotificationService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private _modalService: NgbModal,
    private _querystring: ActivatedRoute,
    private _userslistComponent: UserlistComponent,
    private _dataService: DatatransferService,
    private _teamService: TeamService,
    private _clientService: ClientService,
    private _modulesService: ModulesService)
    {
      this.ViewclientId = this._querystring.snapshot.paramMap.get('clientId');
      this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
      this.currentUserRole = userRoleInfo.data.data.role;
    // for team listing
    // Security hotfix HF-03 (FE-5): copy the shared request so other screens' values do not leak in
    this.listingBodyParameterTeamListing = { ...commonConstant.listingBodyParameterForTeam };
    this.listingBodyParameterTeamListing.stSortColumn = 'stName';
    this.listingBodyParameterTeamListing.stSortOrder = 'desc';
    this.listingBodyParameterTeamListing.stSearchText = '';
    this.action = localStorage.getItem('userAddEditAction');
    if (this.action == '0') {
      this.buttoncaption = 'Create';
    } else {
      this.buttoncaption = 'Save';
    }
    }

  ngOnInit(): void {
    document.body.classList.remove('client-page','team-list-page','add-team-page');
    document.body.classList.add('add-user-page');
    this.userId = this.userId;
    this.validate();
    this.setDataByRoleId();
    this.getRandomColor();
    this.filterTeam = [...this.teams];
    this.filterTeam = this.teams;
    this.filterTeam.forEach((allTeams: any) => {
      allTeams.isShow = true;
    });
  }

  IsAPIUser(event : any){
    var roleId = event.target.value;
    if(roleId == 'f380a6b7-aaf7-4cf0-a60e-264ce91a6f0c'){
      this.el.nativeElement.style.display='block';
      this.GenerateTokenWhileAdding();
    }
    else {
      this.el.nativeElement.style.display='none';
    }
  }

  setDataByRoleId() {
    if (this.getUserRole.name.toLowerCase() == "client admin") {
      this.isClientAdmin = true;
      this.ViewclientId = this.loCurrentUserData.clientId;
      this.ViewClienName = localStorage.getItem('ViewClienName');//this.loCurrentUserData.name;
    }
    else {
      this.ViewclientId = this._querystring.snapshot.paramMap.get('clientId');
      this.ViewClienName = localStorage.getItem('ViewClienName');
      // localStorage.removeItem('ViewClienName');
    }

    if(!this.ViewclientId){
      this.ViewclientId = this.loCurrentUserData.clientId;
    }
    // Security hotfix HF-03 (FE-5): offer the client's teams from the list the API accepts
    this.getClientTeams();

    this.action = localStorage.getItem('userAddEditAction');

    // Add - 0
    if (this.action == '0') {
      this.buttoncaption = 'Create';
      this.AccessToken = Guid.create();
      this.AccessToken = this.AccessToken.value.replace(/-/g, '');
      this.userForm.reset();
      this.userForm.get('role')?.setValue("");
      this.userForm.get('team')?.setValue("");
      this.userForm.get('isActive')?.setValue(1);
      this.userForm.get('colorCode')?.setValue('#FF0000');
      this.userForm.get('isVisibleWebPage')?.setValue(this.isWebPageToggleEnabled);
      this.iscolorvisible = 0;
    }
    else {
      // Edit - 1

      if (this.userId != null && this.userId != undefined) {
        this.getUserById(this.userId);
      }
      this.iscolorvisible = 1;
      this.buttoncaption = 'Save';
    }
    // Set team value
    if(this.teams?.length < 0) {
      this.userForm.get('team')?.setValue('');
    }
  }

  keyPress(e:any) {
    if (e.which === 32) {
      e.preventDefault();
      // invalid character, prevent input
    }
  }

  getClientTeams() {
    let uiClientId = this.ViewclientId;//'3FA85F64-5717-4562-B3FC-2C963F66AFA6';

    this._userService.GetClientTeamByClientId(uiClientId).subscribe(
      {
        next: (response) => {
          if (!!response) {
            // Security hotfix HF-03 (FE-5): clientTeams is already an array of {uiTeamId, stName},
            // and the API accepts only these teams, so the picker offers every active team of the client
            if(response.clientTeams != null && response.clientTeams.length > 0){
              this.teams = response.clientTeams;
              this.filterTeam = this.teams.map((team: any) => ({ ...team, isShow: true }));
            }
          }
        },
        error: (error) => {
          if (error.status == 0) {
            this._notificationService.showError(error.message, 'Error'); // unknown error
          } else if (error.status == 500) {
            this._notificationService.showError("Internal server error.", 'Error');
          }
        }
      });
  }

  filterTeamInfo(event: any) {
    const searchValue = event.target.value.toLowerCase();
    this.filterTeam = this.teams.map((team: any) => ({
      ...team, // Clone the object
      isShow: team.stName.toLowerCase().includes(searchValue)
    }));
  }

  toggleOption(teamId: number) {
    let selectedData = this.userForm.controls['team'].value;
    const index = this.selectedTeams.indexOf(teamId.toString());
    if (index >= 0) {
      // If the member is already selected, deselect it
      this.selectedTeams.splice(index, 1);
    } else {
      // If not selected, add it to the selection list
      this.selectedTeams.push(teamId.toString());
    }
    this.userForm.get('team')?.setValue(this.selectedTeams == null ? [] : this.selectedTeams);
  }

  markedAsChecked(isChecked: boolean) {
    if (isChecked) {
      this.renderer.addClass(this.checkAllSelectOptions.nativeElement.firstChild, 'mat-pseudo-checkbox-checked');
    } else {
      this.renderer.removeClass(this.checkAllSelectOptions.nativeElement.firstChild, 'mat-pseudo-checkbox-checked');
    }
  }
  
  openDropdown(select: MatSelect) {
    select.open();
  }
  
  getUserById(userId: string) {
    this.spinner.show();
    this._userService.getUserById(userId).subscribe(
      {
        next: (response) => {
          if (!!response) {
            this.userDataById = response;
            let arrName = response.stName.split(" ");
            let Teams = response.stTeamId?.split(",");
            if (Teams != null) {
              this.selectedTeams = Teams.map((teams: any) =>
                teams.toLowerCase().trim(' ')
              );
            }
            let contact = response.contact;
            let formattedContact = contact;
            if (contact) {
              let digits = contact.replace(/\D/g, "");
              if (digits.length === 11 && digits.startsWith("1")) {
                digits = digits.substring(1); 
              }
              if (digits.length === 10) {
                formattedContact = `+1 (${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
              }
            }
            this.isReadonly = true;
            this.userForm.get('firstName')?.setValue(arrName[0]);
            this.userForm.get('lastName')?.setValue(arrName[1]);
            this.userForm.get('email')?.setValue(response.email);
            this.userForm.get('contactNo')?.setValue(formattedContact);
            this.userForm.get('role')?.setValue(response.roleId);
            this.userForm.get('isActive')?.setValue(response.isActive);
            this.userForm.get('isPreview')?.setValue(response.flgIsPreview);
            this.userForm.get('isVisibleWebPage')?.setValue(response.flgIsVisibleWebPage);
            this.isWebPageToggleEnabled = response.isWebPageToggleEnabled;
            this.webPageToggle.emit(this.isWebPageToggleEnabled);
            if (!this.isWebPageToggleEnabled) {
              this.userForm.get('isVisibleWebPage')?.disable();
            } else {
                 this.userForm.get('isVisibleWebPage')?.enable();
            }
            if(response.stTeamId == null){
              this.userForm.get('team')?.setValue('');
            }
            else{
              this.userForm.get('team')?.setValue(this.selectedTeams == null ? [] : this.selectedTeams);
              //this.userForm.get('team')?.setValue(response.uiTeamId);
            }

            this.AccessToken = response.apiAccessToken;
            this.userForm.get('colorCode')?.setValue(response.colorCode);

            if(response.roleId == 'f380a6b7-aaf7-4cf0-a60e-264ce91a6f0c'){
              this.el.nativeElement.style.display='block';
            }
            else{
              this.el.nativeElement.style.display='none';
            }
            this.spinner.hide();
          }
        },
        error: (error) => {
          this.spinner.hide();
          if (error.status == 0) {
            this._notificationService.showError(error.message, 'Error'); // unknown error
          } else if (error.status == 500) {
            this._notificationService.showError("Internal server error.", 'Error');
          }
          else {
            this._notificationService.showError(
              error.error.errorMessage,
              'Error'
            );
          }
        }
      }


    );
  }

  // Validate form
  validate() {
    this.userForm = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(commonConstant.emailregex)]],
      contactNo: ['', [Validators.required,  Validators.pattern(/^\+1 \(\d{3}\) \d{3}-\d{4}$/)]],
      role: ['', [Validators.required]],
      team: [''],
      colorCode: [''],
      isActive:['', [Validators.required]],
      isVisibleWebPage:[{ value: false, disabled: !this.isWebPageToggleEnabled }],
      isPreview: [false],
    })
  }
  
  // Check email validation
  getErrorEmail() {
    return this.userForm.get('email')?.hasError('required') ? 'Please enter valid email' :
      this.userForm.get('email')?.hasError('pattern') ? 'Please enter valid email' :
        this.userForm.get('email')?.hasError('alreadyInUse') ? 'This email address is already in use' : '';
  }

  // Convenience for easy access to form fields
  get Usergetter() {
    return this.userForm.controls;
  }

  // On color selection
  onChangeColor(code: any) {
    this.selectedColorCode = code.target.value;
  }
  getRandomColor() {
    var color = Math.floor(0x1000000 * Math.random()).toString(16);
    this.Randomcolor = '#' + ('000000' + color).slice(-6);
    return this.Randomcolor;
  }

  onSubmit() {
    this.submitted = true;
    // Return if form in invalid
    if (this.userForm.invalid) {
      return;
    }
    if(this.userForm.value.role != 'e8921831-15b5-496d-9dcb-f75232ccea08'){
      this.userForm.get('isPreview')?.setValue(false);
    }
    this.spinner.show();

    this.userFormdata = this.userForm.value;

    let formattedPhoneNo, selectedTeam: any;
    if (this.userId == undefined) {
      let pNo1 = this.userForm.value.contactNo.slice(0, 3);
      let pNo2 = this.userForm.value.contactNo.slice(3, 6);
      let pNo3 = this.userForm.value.contactNo.slice(6, 12);

      formattedPhoneNo = '(' + pNo1 + ')' + ' ' + pNo2 + '-' + pNo3;
    }
    else {
      if (this.userForm.value.contactNo.startsWith("(", 0)) {
        formattedPhoneNo = this.userForm.value.contactNo;
      }
      else {
        let pNo1 = this.userForm.value.contactNo.slice(0, 3);
        let pNo2 = this.userForm.value.contactNo.slice(3, 6);
        let pNo3 = this.userForm.value.contactNo.slice(6, 12);

        formattedPhoneNo = '(' + pNo1 + ')' + ' ' + pNo2 + '-' + pNo3;
      }

    }

    
    if (this.userForm.value.team == "") {
      selectedTeam = null;
    }
    else {
      selectedTeam = this.userForm.value.team.toString();
    }
    let fn = this.userForm.value.firstName;
    let ln = this.userForm.value.lastName;
    let eml = this.userForm.value.email;
    this.userFullName = fn + " " + ln;
    if(this.userForm.value.role != ("F380A6B7-AAF7-4CF0-A60E-264CE91A6F0C").toLowerCase()){
      this.AccessToken = null;
    }
    else{
      this.AccessToken;
    }
    let userDataModel = {
      phoneNumber: this.userForm.value.contactNo,
      emailAddress: eml.trim(),
      stName: fn.trim() + ' ' + ln.trim(),
      uiClientId: this.ViewclientId,
      uiRoleId: this.userForm.value.role,
      stTeamId: selectedTeam,
      colorCode: this.Randomcolor,
      apiAccessToken : this.AccessToken,
      uiCreatedBy : this.loCurrentUserData.userId,
      inRegistrationType : 1,
      status: this.userForm.value.isActive,
      isVisibleWebPage: this.userForm.get('isVisibleWebPage')?.value,
      flgIsPreview: this.userForm.value.isPreview
    };
    let userDataModelupadte = {
      phoneNumber: this.userForm.value.contactNo,
      emailAddress: eml.trim(),
      stName: fn.trim() + ' ' + ln.trim(),
      uiClientId: this.ViewclientId,
      uiRoleId: this.userForm.value.role,
      stTeamId: selectedTeam,
      stcolorCode: this.userForm.value.colorCode,
      apiAccessToken : this.AccessToken,
      uiUpdatedBy : this.loCurrentUserData.userId,
      inRegistrationType : 1,
      status: this.userForm.value.isActive,
      isVisibleWebPage: this.userForm.get('isVisibleWebPage')?.value,
      flgIsPreview: this.userForm.value.isPreview
    };

    let act = localStorage.getItem('userAddEditAction');
      if (act == '0') {
        this._userService.userCreate(userDataModel).subscribe(
          {
            next: (response: any) => {
              if (!!response) {
                if (response.statusCode == 200) {
                  localStorage.removeItem('userAddEditAction');
                  this._notificationService.showSuccess(response.message, 'Success'); // unknown error
                  this.hideModal();
                  if (this.isClientAdmin) {
                    let updateLocalStorage = {
                      accessToken: this.loCurrentUserData.accessToken,
                      clientExpiration: this.loCurrentUserData.clientExpiration,
                      clientId: this.loCurrentUserData.clientId,
                      clientName: this.loCurrentUserData.clientName,
                      contactName: this.loCurrentUserData.contactName,
                      email: this.loCurrentUserData.email,
                      isFlgIsClientExpired: this.loCurrentUserData.isFlgIsClientExpired,
                      isSuperAdmin: this.loCurrentUserData.isSuperAdmin,
                      isflgIsSetupPassword: this.loCurrentUserData.isflgIsSetupPassword,
                      name: this.loCurrentUserData.name,
                      profileImage: this.loCurrentUserData.profileImage,
                      roleId: this.loCurrentUserData.roleId,
                      teamId: selectedTeam, //this.loCurrentUserData.teamId,
                      teamName: this.loCurrentUserData.teamName,
                      userId: this.loCurrentUserData.userId,
                    };

                    localStorage.setItem('currentUserData', JSON.stringify(updateLocalStorage));
                  }
                  this._userslistComponent.getRoleByRoleId(() => {
                    this.getTeams();
                    this.getClientDetails();
                    this.getUserByEmail();
                  });
                }
              }
            },
            error: (error) => {
              this.spinner.hide();
              if (error != undefined) {
                if (error.status == 401 && error.statusText == "Unauthorized") {
                  this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
                }
              }
              if (error.status == 0) {
                this._notificationService.showError(error.message, 'Error'); // unknown error
              } 
              else if (error.status == 500) {
                this._notificationService.showError("Internal server error.", 'Error');
              }
              else {
                this._notificationService.showError(error.error[0].errorMessage, 'Error'); // manage fluent validation message
              }
            }
          });
      }
      else {
        // Update User
        this._userService.userUpdate(userDataModelupadte, this.userId).subscribe(
          {
            next: (response: any) => {
              if (!!response) {
                if (response.statusCode == 200) {
                  localStorage.removeItem('userAddEditAction');
                  this.spinner.hide();
                  this._notificationService.showSuccess(response.message, 'Success'); // unknown error
                  this.hideModal();


                  if (this.isClientAdmin) {
                    let updateLocalStorage = {
                      accessToken: this.loCurrentUserData.accessToken,
                      clientExpiration: this.loCurrentUserData.clientExpiration,
                      clientId: this.loCurrentUserData.clientId,
                      clientName: this.loCurrentUserData.clientName,
                      contactName: this.loCurrentUserData.contactName,
                      email: this.loCurrentUserData.email,
                      isFlgIsClientExpired: this.loCurrentUserData.isFlgIsClientExpired,
                      isSuperAdmin: this.loCurrentUserData.isSuperAdmin,
                      isflgIsSetupPassword: this.loCurrentUserData.isflgIsSetupPassword,
                      name: this.loCurrentUserData.name,
                      profileImage: this.loCurrentUserData.profileImage,
                      roleId: this.loCurrentUserData.roleId,
                      teamId: selectedTeam, //this.loCurrentUserData.teamId,
                      teamName: this.loCurrentUserData.teamName,
                      userId: this.loCurrentUserData.userId
                    };

                    localStorage.setItem('currentUserData', JSON.stringify(updateLocalStorage));
                    //// this._eventemitterService.setUpdatedUserData(this.userFullName);
                  }
                  this._userslistComponent.getRoleByRoleId(() => 
                  {
                    this.getTeams();
                    this.getTeamDetails();
                    this.getUserByEmail();
                  });
                }
              }
            },
            error: (error) => {
              this.spinner.hide();
              if (error != undefined) {
                if (error.status == 401 && error.statusText == "Unauthorized") {
                  this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
                }
              }
              if (error.status == 0) {
                this._notificationService.showError(error.message, 'Error'); // unknown error
              } 
              else if (error.status == 500) {
                this._notificationService.showError("Internal server error.", 'Error');
              }
              else{
                this._notificationService.showError(error.error[0].errorMessage, 'Error'); // manage fluent validation message
              }
            }
          });
        }

    //update header team details
    this.getUserTeam();
  }


  getUserTeam(){
    this._userService.GetUserTeamByUserId(this.loCurrentUserData.userId).subscribe({
      next: (response) => {
        if (!!response) {
          if (response.userTeams != null && response.userTeams.length > 0) {
            // Split the teamId string into an array
            if(this.loCurrentUserData.teamId != null && this.loCurrentUserData.teamId != ""){
            const teamIds = this.loCurrentUserData.teamId.toLowerCase().split(',');            
            
            var updateCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
  
            // Initialize teamDetails array if it doesn't exist
            if (!updateCurrentUserData.teamDetails) {
              updateCurrentUserData.teamDetails = [];
            }
            
            // Loop through the teams and add each team details to the teamDetails array
            response.userTeams.forEach((team:any) => {
              const teamDetail = {
                uiTeamId: team.uiTeamId,
                stName: team.stName
              };
              
              // Only add if not already in the teamDetails array
              if (!updateCurrentUserData.teamDetails.some((existingTeam:any) => existingTeam.uiTeamId === teamDetail.uiTeamId)) {
                updateCurrentUserData.teamDetails.push(teamDetail);
              }
            });
            
            // Save the updated localStorageData back to localStorage
            localStorage.setItem('currentUserData', JSON.stringify(updateCurrentUserData));
            this._dataService.sendDataBetweenComponents(updateCurrentUserData);
          }
        }
        }
      },
      error: (error) => {
        if (error.status == 0) {
          this._notificationService.showError(error.message, 'Error'); // unknown error
        } else if (error.status == 500) {
          this._notificationService.showError("Internal server error.", 'Error');
        }
      }
    });
  }

  reset() {
    this.userForm.reset();
  }

  // Hide Modal
  hideModal() {
    this._modalService.dismissAll("");
  }

  // for team lising
  getTeamDetails() {
    // Security hotfix HF-03 (FE-5): list every team of the client
    this.listingBodyParameterTeamListing.teamId = null;
    this._teamService.getTeams(this.listingBodyParameterTeamListing).subscribe(
      {
        next: (response) => {
          if (!!response) {
            if (response.statusCode == 200) {
              this._dataService.sendDataBetweenComponentsForTeamListing(response.data.resultSet);
            }
          }
        },
        error: (error) => {
          this.teamResponse = {
            resultSet: []
          };
          this._dataService.sendDataBetweenComponentsForTeamListing(this.teamResponse);
        }
      });
  }

  getTeams() {
    this.spinner.show();
    this._modulesService.getRoleByRoleId(this.loCurrentUserData.roleId).subscribe(
      {
        next: (response: any) => {
          if (!!response) {
            if (response.statusCode == 200) {
              if (response.data.role.name.toLowerCase() == "client admin") {
                this.listingBodyParameterTeamListing.uiClientId = this.loCurrentUserData.clientId;
                this.ViewclientId = this.loCurrentUserData.clientId;
              }
              else {
                // Security hotfix HF-03 (FE-5): without a client in the route, use the user's own
                const routeClientId = this._querystring.snapshot.paramMap.get('clientId');
                this.listingBodyParameterTeamListing.uiClientId = routeClientId || this.loCurrentUserData.clientId;
                this.ViewclientId = routeClientId || this.loCurrentUserData.clientId;
              }
              this.getTeamDetails();
              this.getClientDetails();
              this.spinner.hide();
            }
          }
        },
        error:(error) => {
          this.spinner.hide();
          this.getClientDetails();
          // this.getTeamDetails();
        }
      });
  }


  getClientDetails() {
    let dt = {
      clientId: this.ViewclientId,
      stSearchText: "",
      stSortColumn: "stClient",
      stSortOrder: "",
      inOffset: 0,
      inLimit: 0
    };
    this._clientService.viewClient(dt).subscribe(
      {
        next: (response) => {
          if (!!response) {
            if (response.statusCode == 200) {
              this._dataService.sendDataBetweenComponentsCLientViewPageCounts(response.data.resultSet[0]);
            }
          }
        },
        error: (error) => {
        }
      });
  }

  getUserByEmail() {
    let clientId = this.ViewclientId;
    let searchText = ""
    this._teamService.getUserByEmail(this.ViewclientId, searchText).subscribe(
      {
        next: (response) => {
          if (!!response) {
            if (response.statusCode == 200) {
              this._dataService.sendDataBetweenComponentsForTeamMember(response.data.users);
            }
          }
        },
        error: (error) => {
        }
      });
  }

  GenerateTokenWhileAdding() {
    this.AccessToken = Guid.create();
    this.AccessToken = this.AccessToken.value.replace(/-/g, '');
  }

  CopyToken(val: string){
    let textarea = null
    textarea = document.createElement('textarea');
      textarea.style.position = 'fixed';
      textarea.style.left = '0';
      textarea.style.top = '0';
      textarea.style.opacity = '0';
      textarea.value = val;
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }

    onToggleChange(event: Event, formControlName: string) {
      const isChecked = (event.target as HTMLInputElement).checked;
      if(formControlName=="isVisibleWebPage"){
        this.userForm.get(formControlName)?.setValue(isChecked ? true : false);
      }
      else{
         this.userForm.get(formControlName)?.setValue(isChecked ? 1 : 0);
      }
    }

}